export default "__VITE_ASSET__CRkaT6bz__"